import { RefObject, useState } from 'react';

export const useToggleInputValueVisible = (
  inputRef: RefObject<HTMLInputElement | null>
) => {
  const [isValueVisible, setIsValueVisible] = useState(false);

  const toggleValueVisibility = () => {
    setIsValueVisible(!isValueVisible);

    if (inputRef?.current) {
      setTimeout(() => {
        const input = inputRef.current;
        if (
          input &&
          input.ownerDocument &&
          input.ownerDocument.contains(input)
        ) {
          try {
            const { length } = input.value || '';
            input.focus();
            input.setSelectionRange(length, length);
          } catch {
            // Silently ignore Range API errors if element was removed
          }
        }
      }, 0);
    }
  };

  return { isValueVisible, setIsValueVisible, toggleValueVisibility };
};
